import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TooltipLabel } from '../../../design-system'
import { TooltipLabelText } from './tooltip-label-text'

export function Name({ name }: { readonly name: string }) {
  return (
    <FormattedMessage id="title_name">
      {(label) => {
        return (
          <TooltipLabel
            label={label as any}
            renderValue={() => {
              return <TooltipLabelText>{name}</TooltipLabelText>
            }}
          />
        )
      }}
    </FormattedMessage>
  )
}
